export default __webpack_public_path__ + "static/media/toast-warn.42ac1696.svg";